import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Clickable from 'components/Common/Clickable'
import { StyledSvgIcon } from 'LuxKit/SvgIcon'
import interactiveFocusStyle from 'styles/utils/interactiveFocusStyle'
import { mediaHoverable } from 'lib/theme/mediaQueries'

export const OfferFilterSelectButton = styled(Clickable)`
  padding: ${rem(8)} ${rem(12)};
  height: 100%;
  width: 100%;
  transition: box-shadow 0.2s, background-color 0.2s, color 0.2s;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  box-shadow: inset 0 0 0 1px ${props => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.S};
  display: flex;
  align-items: center;
  gap: ${rem(12)};
  position: relative;

  ${mediaQueryUp.tablet} {
    padding: ${rem(12)};
  }

  > ${StyledSvgIcon} {
    color: ${props => props.theme.palette.neutral.default.one};
  }

  ${mediaHoverable} {
    &:hover {
      background-color: ${props => props.theme.palette.neutral.default.seven};
    }
  }

  &:focus {
    ${interactiveFocusStyle}
  }

  &.active {
    z-index: 1;
    box-shadow: inset 0 0 0 2px  ${props => props.theme.palette.brand.primary.normal};
  }

  &.invalid {
    box-shadow: inset 0 0 0 1px ${props => props.theme.palette.messaging.critical.normalForeground};
  }

  &:disabled {
    color: ${props => props.theme.palette.neutral.default.four};

    > ${StyledSvgIcon} {
      color: ${props => props.theme.palette.neutral.default.four};
    }
  }
`

export const OfferFilterSelectButtonContent = styled.div`
  flex-grow: 1;
  overflow: hidden;
`
